import { IonAlert, IonButton, IonIcon, IonLabel, isPlatform } from "@ionic/react";
import React, { useState } from "react";
import { add } from "ionicons/icons";
import { Organization } from "../../models";
import { useHistory } from "react-router";
import { isWindows } from "../../utilities/platform/Platform";

const CreateSeasonButton: React.FC<{organization: Organization}> = ({organization}) => {

    const history = useHistory();
    const [showAlert, setShowAlert] = useState(false);

    const onCreatePostHandler = () =>{
       if(!organization) {
            setShowAlert(true);
            return;
       }
       history.push("/index/staff/organization/org-seasons/create/" + organization.id);
    }

    return (
        <React.Fragment>
            <IonButton 
                onClick={onCreatePostHandler}
            >
                <IonIcon icon={add} />
                {(isWindows() || (isPlatform("desktop"))) && <IonLabel>Add New</IonLabel>}
            </IonButton>
            <IonAlert
                isOpen={showAlert}
                onDidDismiss={() => setShowAlert(false)}
                header={"Season Not Found"}
                message={"Before creating an season, finish setting up an organization."}
                buttons={[
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        handler: () => {
                            history.push("/index/staff/organization/org-seasons/" + organization?.id);
                        }
                    },
                    {
                        text: 'Set Up',
                        handler: () => {
                            history.push("/index/staff/organization");
                        }
                    }
                ]}
            />
        </React.Fragment>
    );
};

export default CreateSeasonButton;
